import { Global } from "@emotion/react";

export default function HelveticaNeueFont() {
  return (
    <Global
      styles={`
      @font-face {
        font-family: 'Helvetica Neue';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/helvetica-neue/bold.woff2') format('woff2'), url('/fonts/helvetica-neue/bold.woff') format('woff');
      }
      @font-face {
        font-family: 'Helvetica Neue';
        font-style: italic;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/helvetica-neue/bold-italic.woff2') format('woff2'), url('/fonts/helvetica-neue/bold-italic.woff') format('woff');
      }
      @font-face {
        font-family: 'Helvetica Neue';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url('/fonts/helvetica-neue/medium.woff2') format('woff2'), url('/fonts/helvetica-neue/medium.woff') format('woff');
      }
      @font-face {
        font-family: 'Helvetica Neue';
        font-style: italic;
        font-weight: 500;
        font-display: swap;
        src: url('/fonts/helvetica-neue/medium-italic.woff2') format('woff2'), url('/fonts/helvetica-neue/medium-italic.woff') format('woff');
      }
      @font-face {
        font-family: 'Helvetica Neue';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/helvetica-neue/normal.woff2') format('woff2'), url('/fonts/helvetica-neue/normal.woff') format('woff');
      }
      @font-face {
        font-family: 'Helvetica Neue';
        font-style: italic;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/helvetica-neue/normal-italic.woff2') format('woff2'), url('/fonts/helvetica-neue/normal-italic.woff') format('woff');
      }
      `}
    />
  );
}
